/* eslint-disable @typescript-eslint/no-explicit-any */
export enum EntityTypeSR {
    Legal = 'Firma',
    Physical = 'Fizicko lice',
}
